import React, {Component} from 'react'
import {Button} from 'reactstrap'
import ReactTable from 'react-table'
import PropTypes from 'prop-types'
import {Query, Mutation} from 'react-apollo'
import _ from 'lodash'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import QUERY from '../../../queries/fee_drawdown_report_project_detail'
import exportFeeDrawdownMutation from '../../../queries/reports/export_fee_drawdown'
import moment from "moment/moment";
import numeral from "numeral";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Loading from "../Loading";
import BudgetLabel from '../global/BudgetLabel'

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

const ReactTableFixedColumns = withFixedColumns(ReactTable)

const getTimesheetSums = (timesheets) => {

    if (timesheets) {
        const data =
            timesheets.reduce((carry, timesheet) => {
                carry[moment(timesheet.timesheet_date).format('MMM YYYY')] =
                    (carry[moment(timesheet.timesheet_date).format('MMM YYYY')] || 0) +
                    timesheet.hours_worked * timesheet.role_hourly_rate
                return carry
            }, {})
        return data
    }

    return null
}

const getInvoiceSums = (breakdowns, invoiceTypes) => {

    if (breakdowns) {
        const data =
            breakdowns
                .filter(breakdown => invoiceTypes.includes(breakdown.project_client_invoice.type_id))
                .reduce((carry, breakdown) => {
                    carry[moment(breakdown.project_client_invoice.created_at).format('MMM YYYY')] =
                        (carry[moment(breakdown.project_client_invoice.created_at).format('MMM YYYY')] || 0) + breakdown.amount
                    return carry

                }, {})

        console.log('invoices', data)
        return data
    }

    return null

}

const getMonthTimesheetSums = (budgets) => {

    const timesheets = budgets.reduce((carry, budget) => {
        carry = [...carry, ...budget.timesheets]
        return carry
    }, [])

    console.log('getMonthSums', timesheets)

    return getTimesheetSums(timesheets)

}

const getMonthInvoiceSums = (budgets, invoiceTypes) => {
    const breakdowns = budgets.reduce((carry, budget) => {
        carry = [...carry, ...budget.invoice_breakdowns]
        return carry
    }, [])
    return getInvoiceSums(breakdowns, invoiceTypes)
}

const getAccumulatedSums = (startDate, months, data) => {
    
    const moStartDate = moment(startDate)
    let defaultSums = {}

    for(let i = 0; i < months; i++){
        defaultSums[i] = 0
    }

    const monthSums = Object.keys(data).reduce((carry, month) => {
        const moMonth = moment(month)
        

        const monthDiff = Math.ceil(moMonth.diff(moStartDate, 'month', true))

        carry[monthDiff] = data[month]

        return carry

    }, defaultSums)

    //const moMonth = moment(moStartDate).add(monthNumber, 'months').format('MMM YYYY')

    const sums = Object.keys(monthSums).reduce((carry, month) => {

        const monthNumber = parseInt(month)
        const moMonth = moment(moStartDate).add(monthNumber, 'months').format('MMM YYYY')
        const value = carry[month] + (carry[month-1] || 0)
        carry[month] = value
        carry[moMonth] = value
        return carry

    }, monthSums)


    console.log('sums', sums)

    return sums
}


class Table extends Component {

    render() {

        const {months, data, loading, totalBudget, startDate, timesheetMonths} = this.props

        return (<ReactTableFixedColumns
            data={data.project_activity_budgets}
            loading={loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: 'Budget Detail',
                    fixed: 'left',
                    columns: [
                        
                        {
                            id: 'budget_total',
                            Header: 'Budget',
                            width: 200,
                            accessor: d => `${format(d.budget_total)}`,
                            Footer: row => {
                                return <span><strong>Agreed Fee:</strong> {format(totalBudget)}</span>
                            }
                        },
                        {
                            id: 'work_element',
                            Header: 'Work Element',
                            width: 300,
                            accessor: d => {

                                return (<BudgetLabel 
                                            description={d.project_activity_type.description}
                                            stage={d.stage}
                                            address={d.address ? d.address.full_address : ''}
                                            detail={d.description}
                                        />)

                                /*return (
                                    <div className="d-flex flex-column">
                                        {d.stage && <small>Stage: {d.stage}</small>}
                                        <span>{d.project_activity_type.description}</span>
                                        {d.address && <small>{d.address.full_address}</small>}
                                        {d.description && <small>{d.description}</small>}
                                    </div>
                                )*/
                            }
                        },
                        {
                            id: 'hours_worked',
                            Header: 'Hours Worked',
                            width: 100,
                            accessor: d => `${new Intl.NumberFormat().format(d.hours_worked)}`,
                            Footer: row => {
                                return (<div className="d-flex flex-column align-items-end">
                                            <strong>Total</strong>
                                            <strong>Accumulated</strong>
                                            <strong>Fee Remaining</strong>
                                        </div>)
                            }
                        },
                    ],

                },
                ...months.map((month) => ({
                    Header: month,
                    id: 'description',
                    accessor: 'description',
                    width: 120,
                    Cell: ({original}) => {
                        /*const timesheetsSum = getTimesheetSums(original.timesheets)[month]
                        const supplierSum = getSupplierSums(original.invoice_breakdowns)[month]
                        if (timesheetsSum || supplierSum) {
                            return format((timesheetsSum || 0) + (supplierSum || 0))
                        }*/

                        const invoiceSum = getInvoiceSums(original.invoice_breakdowns, [1, 2])[month]

                        if(invoiceSum) return format(invoiceSum)

                        return null
                    },
                    Footer: row => {

                        /*const timesheetTotal = getMonthTimesheetSums(data.project_activity_budgets)[row.column.Header]
                        const supplierInvoiceTotal = getMonthSupplierSums(data.project_activity_budgets)[row.column.Header]

                        return format((timesheetTotal || 0) + (supplierInvoiceTotal || 0))*/

                        const monthSums = getMonthInvoiceSums(data.project_activity_budgets, [1, 2])
                        const accInvoices = getAccumulatedSums(startDate, timesheetMonths, monthSums)

                        return (
                            <div className="d-flex flex-column">
                                <span>{format(monthSums[row.column.Header] || 0)}</span>
                                <span>{format(accInvoices[row.column.Header])}</span>
                                <span>{format(totalBudget - accInvoices[row.column.Header])}</span>
                            </div>
                        )
                    }
                })),
                {
                    Header: 'Left to Invoice',
                    headerStyle: {textAlign: 'right'},
                    id: 'amount_to_invoice',
                    Cell: ({original}) => {
                        return <div style={{textAlign: 'right'}}>{format(original.amount_to_invoice)}</div>
                    }
                }
            ]}
            showPagination={false}
            className="-striped -highlight"
            manual
        />)
    }
}


const data = {
    total_budget: 'Total Budget',
    total_fees: 'Total Expenditure',
    total_supplier_invoiced: 'Total Supplier',
    total_writeoff: 'Total Written Off',
    total_invoiced: 'Total Invoiced',
    total_credit_notes: 'Total Credit Notes',
    amount_to_invoice: 'Amount to Invoice'
}


export default class FeeDrawdownProjectDetail extends Component {


    getMonths = (creationDate, monthsSinceCreation) => {
        let months = []
        for (var i = 0; i < monthsSinceCreation; i++) {
            months.push(moment(creationDate).add(i, 'months').format('MMM YYYY'))
        }
        return months
    }

    render() {

        const project_id = this.props.match.params.project_id
        return (<Query query={QUERY} variables={{project_id}}>
            {({data, loading}) => {

                if (loading) return <Loading/>

                console.log('PROJCST', data)

                const {project: {total_budget, total_fees, total_supplier_invoiced, total_writeoff, total_invoiced, total_credit_notes, amount_to_invoice}} = data

                return (
                    <div>
                        <div className="d-flex flex-row p-3 justify-content-end">
                            <Mutation mutation={exportFeeDrawdownMutation}>
                                {(exportFeeDrawdownMutationFunc, {loading}) => (
                                    <Button
                                        size="sm"
                                        color="primary"
                                        onClick={() => {
                                            exportFeeDrawdownMutationFunc({variables: {project_id}})
                                                .then(({data}) => {
                                                    window.open(data.exportFeeDrawdownReport)
                                                })
                                        }}
                                    >
                                        <FontAwesomeIcon color="#fff" icon={loading ? 'spinner' : 'download'} spin={loading}/>{' '}
                                        {loading ? 'Exporting...' : 'Export Fee Drawdown'}
                                    </Button>
                                )}
                            </Mutation>
                            
                        </div>
                        <div className="d-flex flex-row pb-3 pt-3 pl-2">
                            <div className="d-flex flex-row align-items-center">
                                <h1>{data.project.project_id}</h1>
                                <span className="lead pl-3">{data.project.name}</span>
                            </div>

                            <div className="d-flex flex-row justify-content-around pl-4" style={{flex: 1}}>
                                <div className="d-flex flex-column border-left pl-3" style={{flex: 1}}>
                                    <small>Total Budget:</small>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Budget:</span>
                                        <span className="lead">{format(total_budget)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Expenditure:</span>
                                        <span className="lead">{format(total_fees + total_supplier_invoiced)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Remaining:</span>
                                        <span
                                            className="lead">{format(total_budget - (total_fees + total_supplier_invoiced))}</span>
                                    </div>

                                </div>
                                <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                                    <small>Total Expenditure:</small>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Gravity:</span>
                                        <span className="lead">{format(total_fees)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Suppliers:</span>
                                        <span className="lead">{format(total_supplier_invoiced)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Total:</span>
                                        <span className="lead">{format(total_fees + total_supplier_invoiced)}</span>
                                    </div>

                                </div>
                                <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                                    <small>Total Written Off:</small>
                                    <div style={{flex: 1}} className="d-flex justify-content-center align-items-center">
                                        <span className="lead">{format(total_writeoff)}</span>
                                    </div>

                                </div>
                                <div className="d-flex flex-column border-left pl-3 ml-3" style={{flex: 1}}>
                                    <small>Total Invoiced:</small>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Invoiced:</span>
                                        <span className="lead">{format(total_invoiced)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Credit Notes:</span>
                                        <span className="lead">{format(total_credit_notes)}</span>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between">
                                        <span className="lead">Total:</span>
                                        <span className="lead">{format(total_invoiced + total_credit_notes)}</span>
                                    </div>

                                </div>
                                <div className="d-flex flex-column border-left pl-2 ml-2" style={{flex: 1}}>
                                    <small>Amount to Invoice:</small>
                                    <div style={{flex: 1}} className="d-flex justify-content-center align-items-center">
                                        <span className="lead">{format(amount_to_invoice)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Table
                            startDate={data.project.min_timesheet_date}
                            timesheetMonths={data.project.timesheet_months}
                            months={this.getMonths(data.project.min_timesheet_date, data.project.timesheet_months)}
                            data={data.project}
                            totalBudget={data.project.total_budget}
                        />
                    </div>

                )
            }}
        </Query>)

    }

}
